const initialState = {
  nickname: '',
  last_name: '',
  first_name: '',
  language: '',
  email: '',
  provider: '',
  phone_number: '',
  introduction: '',
  unconfirmed_phone_number: '',
  confirmed_at: '2018-06-15T00:00:00.000Z',
  phone_number_confirmed_at: '2018-06-15T00:00:00.000Z'
}

export default function main(state = initialState, action){
  switch(action.type) {
  case 'SET_STATE_USER_ME':
    return Object.assign({}, state, action.params)
  default:
    return state
  }
}
